"use strict";

exports.__esModule = true;
exports.PREDEFINED_ALERT_SOUNDS = exports.AlertValueWidget = exports.ALERT_SOUND_DEFAULT = exports.ALERT_MAX_AGE_MIN_VALUE = exports.ALERT_MAX_AGE_DEFAULT = exports.ALERT_MAG_AGE_MAX_VALUE = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _timeDefinitions = require("../../timeDefinitions");
var _widgetGroups = require("../widgetGroups");
var _AlertValueElement = require("./AlertValueElement");
var _AlertValueFields = require("./AlertValueFields");
var _AlertValueHeader = require("./AlertValueHeader");
var _AlertValueThumbnail = require("./AlertValueThumbnail");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ALERT_MAX_AGE_DEFAULT = exports.ALERT_MAX_AGE_DEFAULT = 60;
var ALERT_MAX_AGE_MIN_VALUE = exports.ALERT_MAX_AGE_MIN_VALUE = 1;
var ALERT_MAG_AGE_MAX_VALUE = exports.ALERT_MAG_AGE_MAX_VALUE = _timeDefinitions.WEEK_IN_MILLIS / 1000 / 60;
var ALERT_SOUND_DEFAULT = exports.ALERT_SOUND_DEFAULT = "notification/warning";
var PREDEFINED_ALERT_SOUNDS = exports.PREDEFINED_ALERT_SOUNDS = [ALERT_SOUND_DEFAULT, "game/coin", "arcade/level_down", "arcade/upgrade", "system/device_connect", "arcade/jump"];
var AlertValueWidget = exports.AlertValueWidget = {
  name: "AlertValue",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "AlertValueWidget.label",
    defaultMessage: "Alert Value"
  }),
  icon: "trending-up",
  group: _widgetGroups.DIGITAL_LOG_WIDGET,
  createElement: function createElement(props) {
    return {
      type: "AlertValue",
      props: Object.assign({
        width: 256,
        height: 64,
        AlertName: "alert",
        alertMaxAgeInMinutes: 60,
        soundNotification: false,
        hideLabel: false,
        hideTimestamp: false
      }, props),
      children: []
    };
  },
  showInPalette: true,
  isParent: false,
  requiresContexts: [],
  suppliesContexts: [],
  optionalProps: ["fontFamily", "fontSize", "fontWeight", "fontStyle", "textDecoration", "textAlignment", "color", "backgroundColor", "backgroundColorSource", "hideLabel", "hideTimestamp", "alertMaxAgeInMinutes", "soundNotification"],
  requiresProps: ["x", "y", "width", "height", "AlertName"],
  suppliesProps: [],
  propConstraints: {
    width: {
      "default": 256,
      min: 32,
      max: 1024
    },
    height: {
      "default": 64,
      min: 32,
      max: 768
    },
    alertMaxAgeInMinutes: {
      "default": ALERT_MAX_AGE_DEFAULT,
      min: ALERT_MAX_AGE_MIN_VALUE,
      max: ALERT_MAG_AGE_MAX_VALUE
    }
  },
  components: {
    Element: _AlertValueElement.AlertValueElement,
    Fields: _AlertValueFields.AlertValueFields,
    Thumbnail: _AlertValueThumbnail.AlertValueThumbnail,
    Header: _AlertValueHeader.AlertValueHeader
  }
};